import { Navigate, useParams } from "react-router-dom";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";

// The Care Collections deeplink carries an id (`/member/care-collections/{id}`), so a
// static `<Navigate>` would drop it — re-append the wildcard remainder onto
// the SDK's default care-collections path instead.
export const CareCollectionsMemberRouteRedirect = () => {
  const { "*": careCollectionPath } = useParams();
  return (
    <Navigate
      to={`${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/${
        careCollectionPath ?? ""
      }`}
      replace
    />
  );
};
